import { all } from "redux-saga/effects"

import allSaga from "./all/saga"

function* measurementSaga() {
  yield all([allSaga()])
}

export default measurementSaga
